import { ShieldCheck } from "lucide-react";
import { Link } from "react-router-dom";
import { Stagger } from "./Reveal";
import { motion } from "motion/react";
import { fadeUp } from "../motion";
import {
  EMAIL,
  EMAIL_HREF,
  MAPS_URL,
  MOBILE,
  MOBILE_HREF,
  PHONE,
  PHONE_HREF,
  WEBSITE_URL,
  WEBSITE_LABEL,
} from "../config";

export default function Footer() {
  return (
    <footer className="footer">
      <Stagger className="container footer__inner" gap={0.1}>
        <motion.div variants={fadeUp} className="footer__col footer__brand">
          <strong>No. 1 Nails &amp; Spa</strong>
          <span className="footer__slogan">Pamper Yourself!</span>
        </motion.div>

        <motion.div variants={fadeUp} className="footer__col">
          <h6>Visit</h6>
          <p>
            <a
              href={MAPS_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="footer__plain-link"
            >
              5A Market Lane
              <br />
              Manly NSW 2095
            </a>
          </p>
        </motion.div>

        <motion.div variants={fadeUp} className="footer__col">
          <h6>Contact</h6>
          <p>
            <a href={PHONE_HREF} className="footer__plain-link">
              {PHONE}
            </a>
            <br />
            <a href={MOBILE_HREF} className="footer__plain-link">
              {MOBILE}
            </a>
            <br />
            <a href={EMAIL_HREF} className="footer__plain-link">
              {EMAIL}
            </a>
          </p>
        </motion.div>

        <motion.div variants={fadeUp} className="footer__col">
          <h6>Online</h6>
          <p>
            <a
              href={WEBSITE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="footer__plain-link"
            >
              {WEBSITE_LABEL}
            </a>
            <br />
            <Link to="/booking" className="footer__link">
              Book online
            </Link>
          </p>
          <div className="footer__badge">
            <ShieldCheck aria-hidden="true" />
            <span>100% Satisfaction Guaranteed</span>
          </div>
        </motion.div>
      </Stagger>

      <div className="footer__legal container">
        <span>© 2026 No. 1 Nails &amp; Spa Pty Ltd</span>
        <span>Est. 2009</span>
        <span>ABN 99 626 944 714</span>
      </div>
    </footer>
  );
}
